import React, { Component } from 'react'
import Standard from './Standard'

class Multiple extends Component {
  render = () => {
    return <Standard {...this.props} selection multiple />
  }
}

export default Multiple
